<template>
  <DxForm id="formularioServicioEnergia" ref="formInstance" :form-data="model" label-location="top"
  :show-colon-after-label="false" :visible="model != null" validation-group="validacionServicioEnergia">
    <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

    <DxGroupItem :col-span="6" :col-count="6">
      <DxSimpleItem :col-span="6">
        <configuracion-descuentos v-model:model="props.model.Descuentos" :read-only="props.tieneTramitesAsociados"
          ref="configuracionDescuentos" />
      </DxSimpleItem>
    </DxGroupItem>
  </DxForm>
</template>

<script setup lang="ts">
import type { CreateServicioEndesaModel, CreateServicioEnergiaModel, DetailServicioEndesaModel, DetailServicioEnergiaModel } from '@/.shared/.api';
import {
  DxForm,
  DxColCountByScreen,
  DxSimpleItem,
  DxGroupItem
} from "devextreme-vue/form";
import ConfiguracionDescuentos from '@/components/descuentos/ConfiguracionDescuentos.vue';
import { ref } from 'vue';

const configuracionDescuentos = ref<InstanceType<typeof ConfiguracionDescuentos>>();

const props = defineProps({
  model: {
    type: Object as () => DetailServicioEnergiaModel | CreateServicioEnergiaModel | DetailServicioEndesaModel | CreateServicioEndesaModel,
    required: true
  },
  tieneTramitesAsociados: {
    type: Boolean,
    required: true
  }
})

async function validate(): Promise<boolean> {
  return configuracionDescuentos.value?.validate()
    .then((result: { isValid: any; }) => {
      return result.isValid
    });
}

defineExpose({ validate })

</script>